export default "__VITE_ASSET__31e46676__"